import { gEnums } from 'global/enums/globalEnums';
import Wrapper from 'global/wrappers/Wrapper';
import _ from 'lodash';
import { useMatchSchedule } from 'projectSpecific/sports/useHelpers/useMatchSchedule';
import { useMemo } from 'react';
import { _matchDisplayTypes, MatchContentWithProvider } from '../matches/MatchContent';
import MatchFilter from '../matches/MatchFilter';

const oppsOnly = true

export const MatchesSchedule = ({ 
  teamKeys = [],
  matchDisplayType = _matchDisplayTypes.teamMatches,
  matchScheduleDisplayType = gEnums.matchScheduleDisplayTypes.teamSchedule,
  parentKey = '',
  teamKey,
  matchDisplayOptions,
  matchFilter,
}) => {

  const props = {
    // matches,
    teamKeys,
    matchDisplayType,
    matchScheduleDisplayType,
    parentKey,
    teamKey,
    matchDisplayOptions,
    matchFilter,
  }
  const { getScheduleMatches } = useMatchSchedule(props)

  const matches = useMemo(() => {
    const _matches = getScheduleMatches(matchScheduleDisplayType)
    const sortedTeamMatches = _.sortBy(_matches, match => new Date(match.startDate));
    return sortedTeamMatches
  }, [teamKey])

  
  const divs_matches = _.map(matches, (match) => (
    <MatchContentWithProvider
      key={match._itemKey}
      matchKey={match._itemKey}
      match={match}
      matchDisplayType={matchDisplayType}
      parentKey={parentKey}
      teamKey={teamKey}
      matchScheduleDisplayType={matchScheduleDisplayType}
      favTeamKey={match._favTeamKey} // 👈 pass it down if needed
      oppsOnly={oppsOnly}
    />
  ));

  let _cn = _.kebabCase(matchScheduleDisplayType)
  _cn+= ' ' + _.kebabCase(matchDisplayType)

  console.log('matchDisplayType', `${matchDisplayType}-${matchScheduleDisplayType}`) 

  if (oppsOnly &&  matchScheduleDisplayType === gEnums.matchScheduleDisplayTypes.teamSchedule) {
    _cn += ' to'
  }
 
  return <Wrapper
    header={matchDisplayOptions?.showMatchFilter && <MatchFilter />} 
    content={divs_matches}
    css={{ container: _cn }
    }
  />
}


  // if (teamKeys && teamKeys.length > 0) {
  //   // decorate each match with _favTeamKey if found
  //   finalMatches = _.map(matches, (match) => {
  //     const favKey = _.find(teamKeys, (tk) =>
  //       tk === match?.home?.id || tk === match?.away?.id
  //     );
  //     return { ...match, _favTeamKey: favKey || null };
  //   }); 
  //   // prioritize matches with a _favTeamKey
  //   finalMatches = _.orderBy(finalMatches, (m) => (m._favTeamKey ? 0 : 1), "asc");
  // }